//React base styles
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";

// React helper functions
// import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { size } = typography;
const { text } = colors;

const dialogContentText = {
  styleOverrides: {
    root: {
      fontSize: size.md,
      color: text.main,
    },
  },
};

export default dialogContentText;
